<template>
  <div>
    <header-status />
    <div class="conteudo" v-if="notifications">
      <v-layout wrap row>
        <v-flex xs12 mt-2 v-for="(item, i) in notifications" :key="i">
          <v-card>
            <v-card-title>
              <span class="headline">{{item.title}}</span>
              <v-spacer />
              <div class="overline">{{item.created_at | formatDate}}</div>
            </v-card-title>
            <v-card-text>{{item.body}}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <h2 v-if="notifications.length == 0">Nenhuma Notificação foi encontarada</h2>
    </div>

    <dialog-loader :active="notifications == null"></dialog-loader>
  </div>
</template>

<script>
import { authService } from "../plugins/firebase";
export default {
  data() {
    return {
      notifications: null
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };
      this.notifications = await this.getNotifications(config);
      console.log(Array.isArray(this.notifications));
      console.dir(this.notifications);
    },
    getNotifications(config) {
      return this.$http
        .get(this.$SERVE + "/students/notifications", config)
        .then(response => {
          return response.data;
        });
    }
  }
};
</script>

